import TV from "./AoTv-p";
import createFeed from './AoTv-datafeed'
import { getLang } from '@/utils/auth'
import {new_data} from "@/api/index";

var TIMER = null
var klineTimer = null;
function AoWidget({ container_id, width, height, priceScale = 1000, symbol, type = 2}) {
    this.priceScale = 10000
    this.symbol = symbol
    this.currency = symbol.split('/')[0]
    this.widget = null
    this.container_id = container_id
    this.width = width
    this.height = height
    this.type = type
    if (TIMER) clearInterval(TIMER)
    if (klineTimer) clearInterval(klineTimer)

    this.next_timeshar_url = window.GLOBAL.HOST + 'web/new_timeshar'  // 获取下一条记录

    // http://demo.m88mo.cn/api/currency/new_timeshar?from=1565328534&to=1565414994&symbol=EOS/ETH&period=1min
    this.new_timeshar_url = window.GLOBAL.HOST + 'web/new_timeshar'    // 获取当前数据
    this.prevData = null;
    this.onRealtimeCallback = null
}
AoWidget.prototype.connect = function () {
    // TIMER = setInterval(() => {
    klineTimer = setInterval(()=>{
        let params = {
            symbol: this.symbol.split('/')[0]+'usdt'
        };
        let type = localStorage.getItem('type2');
        let klineData = JSON.parse(localStorage.getItem('klineData'));
        var msg = klineData[type];
        if (typeof msg === 'string') msg = JSON.parse(msg);
        if (msg.symbol == this.symbol && msg.period == type) {
            if (!this.onRealtimeCallback) return;
            _log(msg)
            let newPrice = localStorage.getItem('new_price');
            msg.open = parseFloat(msg.open || msg.Open)
            msg.low = parseFloat(msg.low || msg.Low)
            msg.high = parseFloat(msg.high || msg.High)
            msg.realclose = parseFloat(msg.close || msg.Close);
            // msg.close = parseFloat(msg.close || msg.Close);
            msg.close = newPrice ? parseFloat(newPrice) : parseFloat(msg.close || msg.Close);
            msg.volume = parseFloat(msg.volume || msg.Volume)
            msg.time = parseFloat((msg.Date) * 1000)

            if (this.prevData && msg.time < this.prevData.time) {
                _log(1)
                this.prevData = msg
                return
            }
            if (this.prevData && msg.time > this.prevData.time) {
                this.prevData.close = this.prevData.realclose
                this.prevData.close = parseFloat(this.prevData.close)
                this.onRealtimeCallback(this.prevData)
                this.prevData = msg
                _log(2)
                // console.log(4)
            }
            this.prevData = JSON.parse(JSON.stringify(msg))
            _log(3)
            this.onRealtimeCallback(msg)
        }
    },500)
}
AoWidget.prototype.create = function () {
    var _this = this
    let locale = getLang()
    if (locale == 'tw') locale = 'zh_TW';
    this.widget = new TradingView.widget({
        symbol: this.symbol,
        interval: '1',
        debug: false,
        fullscreen: false,
        autosize: true,
        container_id: this.container_id,
        // datafeed: new Datafeeds.UDFCompatibleDatafeed(
        //     "https://demo_feed.tradingview.com",
        //     1000 * 20000
        // ),
        datafeed: createFeed(this),
        library_path: "/pc/static/tradeview/charting_library/",
        custom_css_url: "/pc/static/tradeview/new.css",
        locale: "en",
        width: this.width,
        height: this.height,
        drawings_access: {
            type: "black",
            tools: [{ name: "Regression Trend" }]
        },
        disabled_features: TV.getDisabledFeatures(),
        enabled_features: TV.getEnabledFeatures(),
        //charts_storage_url: 'http://saveload.tradingview.com',
        charts_storage_api_version: "1.1",
        // toolbar_bg: "#121d32",
        toolbar_bg: "#fff",
        timezone: "Asia/Shanghai",
        studies_overrides: {//#00c483 #d14b65
            "volume.precision": "1000",
            "volume.volume.color.0": "rgba(209, 75, 101,.7)",
            "volume.volume.color.1": "rgba(0, 196, 131,.8)",
            "volume.volume.transparency": 75,    //透明度
        },
        // overrides: {
        // 	"paneProperties.background": "#222222",
        // 	"paneProperties.vertGridProperties.color": "#454545",
        // 	"paneProperties.horzGridProperties.color": "#454545",
        // 	"symbolWatermarkProperties.transparency": 90,
        // 	"scalesProperties.textColor" : "#AAA"
        // },
        // enable_publishing: false,
        // hide_legend: true,
        // save_image: false,
        // supports_search: false,
        overrides: TV.getOverrides(),
        customFormatters: {
            timeFormatter: {
                format: function (date) { var _format_str = '%h:%m'; return _format_str.replace('%h', date.getUTCHours(), 2).replace('%m', date.getUTCMinutes(), 2).replace('%s', date.getUTCSeconds(), 2); }
            },
            dateFormatter: {
                // 07.05.2020-15:30 这样显示
                format: function (date) {
                    //return date.getUTCFullYear() + '/' + date.getUTCMonth() + '/' + date.getUTCDate();
                    let d = date.getUTCDate()+''
                    let m = date.getUTCMonth()+1+''

                    return (d.length==1?'0'+d:d)+'.'+(m.length==1?'0'+m:m)+'.'+date.getUTCFullYear();
                }
            }
        }
    });
    return this
}
AoWidget.prototype.ready = function () {
    var _this = this
    const widget = this.widget
    widget.MAStudies = [];
    widget.selectedIntervalButton = null;
    // widget.setLanguage('en')
    widget.onChartReady(function () {
        //图表方法
        // document.getElementById('trade-view').childNodes[0].setAttribute('style', 'display:block;width:100%;height:100%;');
        //let that =this
        // widget
        //     .chart()
        //     .createStudy(
        //         "Moving Average",
        //         false,
        //         true,
        //         [15, "close", 0],
        //         null,
        //         { "Plot.color": "#e843da" }
        //     );
        // widget.chart().createStudy("MA Cross", false, false, [10, 20]);
         widget.MALine7 = widget.chart().createStudy("Moving Average Exponential", false, false, [5], null, {
                      "plot.color": "#989898",
                      "plot.linewidth": 2
                  });
         widget.MALine15 = widget.chart().createStudy("Moving Average Exponential", false, false, [10], null, {
                  "plot.color": "#bc8b32",
                  "plot.linewidth": 2
              });
          widget.MALine30 = widget.chart().createStudy("Moving Average Exponential", false, false, [30], null, {
              "plot.color": "#cf30af",
              "plot.linewidth": 2
          });
        let buttonArr = TV.buttonArr;
        let btn = {};
        let nowTime = "";
        buttonArr.forEach((v, i) => {
            let button = $(widget.createButton());
            button
                .attr("title", v.text)
                .addClass("my2")
                .text(v.text);

            if (v.text == "1min") {
                button.css({ "background-color": "#2c3b59", color: "#c7cce6" });
                localStorage.setItem("tim", "1"); //默认为1分钟
                localStorage.setItem("type2", "1min"); //默认为1分钟
            }

            // console.log($(this),'999999')
            btn = button.on("click", function (e) {
                $(this)
                    .parents(".wrap-3tiHesTk-")
                    .children()
                    .find(".my2")
                    .removeClass("mydate")
                    .removeAttr("style"); //去掉1分钟的
                handleClick(e, v.value, v.type);
                widget.chart().setChartType(v.chartType); //改变K线类型
            });
        });
        let handleClick = (e, value, type) => {
            // _this.clearTimer()
            // __socket.setSub(type)

            //_this.setSymbol = function (symbol, value) {
            // gh.chart().setSymbol(_this.symbol, value);
            //};
            localStorage.setItem("tim", value);
            localStorage.setItem("type2", type);
            widget.chart().setResolution(value, function onReadyCallback() { }); //改变分辨率

            $(e.target)
                .addClass("mydate")
                .closest("div.space-single")
                .siblings("div.space-single")
                .find("div.button")
                .removeClass("mydate");
        };
    });
}
AoWidget.prototype.update = function (item) {
    for (var key in item) {
        this[key] = item[key]
    }
    this.clearTimer()

    this.remove();
    this.create();
}
AoWidget.prototype.clearTimer = function () {
    if (TIMER) clearInterval(TIMER)
    if (klineTimer) clearInterval(klineTimer)
}
AoWidget.prototype.remove = function () {
    this.clearTimer()

    if (this.widget) {
        this.widget.remove();
        this.widget = null;
    }
}


export default AoWidget



// WEBPACK FOOTER //
// ./src/views/deal/components/AoTv-widget.js